// extracted by mini-css-extract-plugin
export default {"sectionTitle":"phaNDz","domainTitle":"HeO_HQ","pricing":"avgx5M"};